export enum DisplayOccasionType {
  Collection = 'Collection',
  Delivery = 'Delivery',
  Dinein = 'DineIn',
  Takeaway = 'Takeaway'
}
